// GENERAL Button and Tabs Shortcuts

// TAB 1 collapsibles CALL
document.addEventListener("keydown", (event) => {
  if (event.ctrlKey && event.key === "1") {
    event.preventDefault(); // Prevent default browser action
    const details = document.getElementById("details-1");

    // Toggle open state
    details.open = !details.open;
  }
});

document.addEventListener("keydown", (event) => {
  if (event.ctrlKey && event.key === "2") {
    event.preventDefault(); // Prevent default browser action
    const details = document.getElementById("details-2");

    // Toggle open state!!
    details.open = !details.open;
  }
});

document.addEventListener("keydown", (event) => {
  if (event.ctrlKey && event.key === "3") {
    event.preventDefault(); // Prevent default browser action
    const details = document.getElementById("details-3");

    // Toggle open state
    details.open = !details.open;
  }
});

// TAB 3 collapsibles Assitance

document.addEventListener("keydown", (event) => {
  if (event.ctrlKey && event.key === "4") {
    event.preventDefault(); // Prevent default browser action
    const details = document.getElementById("details-4");

    // Toggle open state
    details.open = !details.open;
  }
});

document.addEventListener("keydown", (event) => {
  if (event.ctrlKey && event.key === "5") {
    event.preventDefault(); // Prevent default browser action
    const details = document.getElementById("details-5");

    // Toggle open state
    details.open = !details.open;
  }
});

//  TABS

document.addEventListener("keydown", function (event) {
  // Check if the user pressed Tab (without Shift, Ctrl, Alt, etc.)
  if (
    event.key === "Tab" &&
    !event.shiftKey &&
    !event.altKey &&
    !event.ctrlKey &&
    !event.metaKey
  ) {
    event.preventDefault();

    // Our radio IDs in the order we want to cycle
    const radioIDs = ["tab1", "tab2", "tab3"];

    // Find which radio is currently checked
    let currentIndex = radioIDs.findIndex((id) => {
      return document.getElementById(id).checked;
    });

    // Calculate the next index (wrap around with %)
    let nextIndex = (currentIndex + 1) % radioIDs.length;

    // Check the next radio
    document.getElementById(radioIDs[nextIndex]).checked = true;
  }
});
